import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformativaComponent } from '@hm_app/shared/informativa/informativa.component';

@Component({
    selector: 'ngx-modal',
    styleUrls: ['./alert-info-app.component.scss'],
    templateUrl: './alert-info-app-component.html',
})
export class AlertInfoAppComponent {
    modalHeader = 'Alert title';
    modalOkText = 'OK';
    modalCancelText = 'Cancel';

    modalCancelEnabled: boolean;

    info_app: boolean;

    @Output() action = new EventEmitter<boolean>();

    constructor(
        private activeModal: NgbActiveModal,
        protected modalService: NgbModal,
    ) {
    }

    closeModal(okAction: boolean) {
        this.action.emit(okAction);
        this.activeModal.close();
    }

    openInformativaModale() {
        const activeModal = this.modalService.open(InformativaComponent, {
            size: 'lg',
            container: 'nb-layout',
        });
    }
}
